import uy from '/flags/uy.svg';
import pe from '/flags/pe.svg';
import ar from '/flags/ar.svg';
import bo from '/flags/bo.svg';
import br from '/flags/br.svg';
import cl from '/flags/cl.svg';
import co from '/flags/co.svg';
import ec from '/flags/ec.svg';
import es from '/flags/es.svg';
import mx from '/flags/mx.svg';
import py from '/flags/py.svg';
import us from '/flags/us.svg';
import ve from '/flags/ve.svg';

export const flags = {
  uy,
  pe,
  ar,
  bo,
  br,
  cl,
  co,
  ec,
  es,
  mx,
  py,
  us,
  ve,
};
